<template>
    <b-modal
        id="modal-confirm-reason-log-kas-kecil"
        centered
        :no-close-on-backdrop="isSubmitting"
        :no-close-on-esc="isSubmitting"
        :hide-header-close="isSubmitting"
        :title="title"
    >
        <p class="mb-2">{{ desc }}</p>
        <b-form id="reasonLogKasKecilForm" @submit.prevent="$emit('submit')">
            <b-form-group label="Alasan" class="mb-0">
                <b-form-textarea
                    :value="reason"
                    name="kasKecilReason"
                    rows="3"
                    maxlength="255"
                    required
                    @input="$emit('update:reason', $event.trim())"
                />
                <small class="text-muted">{{ reason.length }}/255</small>
            </b-form-group>
        </b-form>
        <template v-slot:modal-footer="{ cancel }">
            <b-button variant="secondary" :disabled="isSubmitting" @click="cancel()">
                Batal
            </b-button>
            <b-button
                variant="pgiBtn"
                type="submit"
                form="reasonLogKasKecilForm"
                :disabled="isSubmitting"
                name="kasKecilSubmitReasonBtn"
            >
                <b-spinner v-if="isSubmitting" small class="mr-1" />
                Simpan
            </b-button>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: "modal-kas-kecil-reason",
    props: {
        title: { type: String, default: "" },
        desc: { type: String, default: "" },
        isSubmitting: { type: Boolean, default: false },
        reason: { type: String, default: "" },
    },
}
</script>
